import React, { FC } from 'react';
import { ReactComponent as QrCode } from '../../../assets/Links/QrCode.svg';

export const QrCodeIcon: FC = () => <QrCode />;
